import Modal_vue_vue_type_script_setup_true_lang_default from "./Modal.vue.script.js";
//#region src/v2/features/modal/Modal.vue
var Modal_default = Modal_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { Modal_default as default };

//# sourceMappingURL=Modal.vue.js.map